// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VeeValidate from 'vee-validate'
import Vuelidate from 'vuelidate'
import VueAlertify from "vue-alertify"
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import './fonts/HELR65W.woff'
import './fonts/Roboto-Regular.woff'
import VueApexCharts from 'vue-apexcharts'
import VueSimpleAlert from "vue-simple-alert";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import CryptoJS from 'crypto-js';
import moment from 'moment'

/*
  JIRA: HUB-4872
  Keycloak package to authenticate user
  JWT package to decode token
*/
import Keycloak from 'keycloak-js';
import VueJwtDecode from 'vue-jwt-decode';
import interceptorsSetup from './helpers/interceptors';
import apiUrl from './constants';
//

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
import VuejsDialog from 'vuejs-dialog'
// const options = {
//     position: 'bottom-right'
// }
// import Drag from 'sortablejs'

Vue.use(VueSimpleAlert);
Vue.use(VueAlertify)
Vue.use(VeeValidate)
Vue.use(Vuelidate)

Vue.use(BootstrapVue)
Vue.use(VCalendar)
Vue.use(Toast)
Vue.use(VuejsDialog, {
  message: 'Please confirm action'
})

// Globally suppress Vue warnings
Vue.config.warnHandler = function (msg, vm, trace) {
  // Hides only the .native warning
  if (msg.includes('.native modifier')) {
    return;
  }
  // Show the rest or Other Vue warnings still show
  console.warn('[Vue warn]: ' + msg + trace);
};

// Vue.use(Drag)
// Vue.directive('sortable', {
//   inserted: function (el, binding) {
//     new Sortable(el, binding.value || {})
//   }
// })

/* eslint-disable no-new */

/*
  JIRA: HUB-4872
  Keycloak authentication & JWT to decode token
  Check if Kavach authentication flag is enabled
*/
if(apiUrl.isKavachLogin){

  let initOptions = {
    url: apiUrl.api_url_kavach_auth, realm: 'xpressbees', clientId: 'hubops-ui', onLoad: 'login-required'
  }

  let keycloak = new Keycloak(initOptions);
  keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {

    if (!auth) {
      localStorage.clear();
      window.location.reload();
    } else {
      localStorage.setItem('access_token', keycloak.token);
      const decoded = VueJwtDecode.decode(keycloak.token);

      // Format & encrypt today's date and update in local storage
      var formatedDate = moment(new Date()).format('DD-MM-YYYY');
      var formatedDateEncrypt = CryptoJS.AES.encrypt(JSON.stringify(formatedDate), "Key");
      window.localStorage.setItem('loginDate', formatedDateEncrypt);

      // Middleware to change authorization token for KAVACH
      interceptorsSetup()

      new Vue({
        el: '#app',
        router,
        template: '<App/>',
        components: {
          App
        }
      });

      // Schedule token refresh checks periodically
      setInterval(() =>{
        const currentTime = Math.floor(Date.now() / 1000);
        // Check if the access token is about to expire (e.g., within the next 1 minute)
        if ((keycloak.tokenParsed && keycloak.tokenParsed.exp) && ((keycloak.tokenParsed.exp - currentTime) <= 60)) {
          // Refresh access_token if minimum validity period is 60 seconds
          keycloak.updateToken(60).then((refreshed)=>{

            if (refreshed) {
              localStorage.setItem('access_token', keycloak.token);
            }
            // else {
            //   console.log('Token not refreshed, valid for ' + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
            // }
          }, error => {
            console.error('Failed to refresh token' + error);
          });
        }
      }, 60000) // Check every minute
    }
  }, error => {
    console.error('Authenticated Failed - ' + error.error);
  });
}else{

  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
      App
    }
  });
}



// WEBPACK FOOTER //
// ./src/main.js